export const typeMapping = {
  text: 'text',
  multiple_choice: 'checkbox',
  multi_choice: 'radio',
  number: 'number',
  money: 'money',
  percentage: 'percentage'
};

export function initializeDefaultValues(questions) {
  return questions.reduce((acc, question) => {
    const { users_responses, type, id_question, options } = question;
    const questionName = `${typeMapping[type] || ''}_question_${id_question}`;

    let initialValue = {
      value: type === 'multiple_choice' ? [] : '',
      files: [],
      idResponse: null,
    };

    const userResponse = Array.isArray(users_responses) 
      ? users_responses[0] 
      : users_responses;

    if (userResponse?.response) {
      if (type === 'multiple_choice' || type === 'multi_choice') {
        let responseParts = [];
        let canBeOld = false;

        if (userResponse.response.includes('||')) {
          responseParts = userResponse.response.split('||').map(part => part.trim());
        } else if (
          userResponse.response.includes(',') &&
          !userResponse.response.includes('||')
        ) {
          canBeOld = true;
          responseParts = userResponse.response.split(',').map(part => part.trim());
        } else {
          responseParts = [userResponse.response.trim()];
        }

        const selectedOptions = [];
        options?.forEach(option => {
          if (responseParts.includes(option.description.trim())) {
            selectedOptions.push(option.description);
          } else if (
            !responseParts.includes(option.description.trim()) &&
            canBeOld &&
            userResponse.response.includes(option.description)
          ) {
            selectedOptions.push(option.description);
          }
        });

        initialValue = {
          value: type === 'multi_choice' ? selectedOptions[0] || '' : selectedOptions,
          files: userResponse.response_file || [],
          idResponse: userResponse.id_question_response,
        };
      } else {
        initialValue = {
          value: userResponse.response,
          files: userResponse.response_file || [],
          idResponse: userResponse.id_question_response,
        };
      }
    }

    acc[questionName] = initialValue;
    return acc;
  }, {});
}